import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { MenuEstadisticasOption, OpcionTopNavigation } from '@/objects/Menus';
import TopNavigation from '@/components/elements/TopNavigation';
import EstadisticasPropias from './estadisticas/EstadisticasPropias';
import EstadisticasGenerales from './estadisticas/EstadisticasGenerales';
import { whiteSmoke } from '@/constants/Colors';
import { insertarAnuncioGoogleEnHead } from '@/util/Comun';

function MenuEstadisticas() {

    const [opcionActual, setOpcionActual] = useState<MenuEstadisticasOption>(MenuEstadisticasOption.PROPIAS);

    const { t } = useTranslation();

    const OpcionesBarraMenuMensajes: OpcionTopNavigation[] = [
        { nombre: t("menu:secciones.estadisticas.propias"), tipoOpcion: MenuEstadisticasOption.PROPIAS },
        { nombre: t("menu:secciones.estadisticas.generales"), tipoOpcion: MenuEstadisticasOption.GENERALES },
    ];

    useEffect(() => {
        insertarAnuncioGoogleEnHead();
    }, []);

    const setOpcionActualString = (opcion: string) => {
        setOpcionActual(opcion as MenuEstadisticasOption);
    }

    return (
        <section
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '100%',
                minHeight: 0,
                overflow: 'hidden',
                backgroundColor: whiteSmoke
            }}
        >
            {/* <TituloPrincipalH1 texto={t("menu:secciones.mensajes.titulo")} /> */}
            <TopNavigation
                opciones={OpcionesBarraMenuMensajes}
                opcionActual={opcionActual.toString()}
                setOpcionActual={setOpcionActualString}
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 5,
                    flexShrink: 0,
                }}
            />
            <section
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    width: '100%',
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                }}
            >
                {opcionActual === MenuEstadisticasOption.PROPIAS && <EstadisticasPropias />}
                {opcionActual === MenuEstadisticasOption.GENERALES && <EstadisticasGenerales />}

            </section>
        </section>
    );
}

export default MenuEstadisticas;